<div class="col-lg-12 linktab">
  <mat-tab-group animationDuration="0ms">

    <!-- Linked Items Tab -->
    <mat-tab label="Linked {{ type === 'TASK' ? 'Notes' : 'Tasks' }}">
      <div class="dialog-header-container">
        <h2 class="mar-b-5 pd-t-5px" mat-dialog-title>{{meetingTitle}} </h2>
        <div>
          <button mat-icon-button mat-dialog-close aria-label="Close">
            <mat-icon>close</mat-icon>
          </button>
        </div>
      </div>
      <mat-divider class="mat-divider"></mat-divider>
      <mat-dialog-content class="dialog-without-actions">

        <cdk-accordion class="example-accordion" multi="true">
          <cdk-accordion-item *ngFor="let agenda of filteredAgendas" #accordionItem="cdkAccordionItem"
                              [expanded]="isMinutesExist(agenda)" class="example-accordion-item">

            <!-- Header -->
            <div *ngIf="isMinutesExist(agenda)" class="example-accordion-item-header d-flex align-items-center"
                 (click)="accordionItem.toggle()">
              <button mat-icon-button>
                <mat-icon>{{ accordionItem.expanded ? 'keyboard_arrow_down' : 'keyboard_arrow_right' }}</mat-icon>
              </button>
              <h3 class="margin-0 f-weight">
                <div [innerHTML]="agenda.agendaTitle"></div>
              </h3>
            </div>

            <!-- Body -->
            <div class="example-accordion-item-body" *ngIf="accordionItem.expanded && isMinutesExist(agenda)">
              <ng-container *ngIf="(type === 'TASK' ? getSelectedItemsByAgendaId(agenda.agendaId).data : getSelectedItemsByAgendaId(agenda.agendaId).data).length > 0; else noRecords">
                <table mat-table            [dataSource]="pagedItemsMap[agenda.agendaId] || []"

                       class="col-12 mat-elevation-z2 demo-table">

                  <!-- Select Column -->
                  <ng-container matColumnDef="select">
                    <th mat-header-cell *matHeaderCellDef>
                      <mat-checkbox (change)="masterToggle(agenda.agendaId, 'selected')"
                      [checked]="isAllSelected(agenda.agendaId, 'selected')"></mat-checkbox>
                    </th>
                    <td mat-cell *matCellDef="let element">
                             <mat-checkbox (click)="$event.stopPropagation()"
                                    (change)="toggleSelection(element)"
                                    [checked]="selection.isSelected(element)">
                      </mat-checkbox>
                    </td>
                  </ng-container>

                  <!-- Dynamic Columns -->
                  <ng-container *ngIf="type === 'TASK'">
                    <ng-container matColumnDef="noteDescription">
                      <th mat-header-cell *matHeaderCellDef class="header-style"> Note </th>
                      <td mat-cell *matCellDef="let element"[innerHTML]="element.noteDescription" class="header-style"></td>
                    </ng-container>
                    <!-- <ng-container matColumnDef="createdByName">
                      <th mat-header-cell *matHeaderCellDef> Created By </th>
                      <td mat-cell *matCellDef="let element">{{ element.createdByName }}</td>
                    </ng-container> -->
                  </ng-container>

                  <ng-container *ngIf="type === 'NOTE'">
                    <ng-container matColumnDef="taskTitle">
                      <th mat-header-cell *matHeaderCellDef class="header-style"> Task </th>
                      <td mat-cell *matCellDef="let element"[innerHTML]="element.taskTitle" class="header-style"></td>
                    </ng-container>
                    <ng-container matColumnDef="createdByName">
                      <th mat-header-cell *matHeaderCellDef class="header-style"> Assigned By </th>
                      <td mat-cell *matCellDef="let element" class="header-style">{{ element.createdByName }}</td>
                    </ng-container>
                    <ng-container matColumnDef="assignedTo">
                      <th mat-header-cell *matHeaderCellDef class="header-style"> Assigned To </th>
                      <td mat-cell *matCellDef="let element" class="header-style">
                        {{ assignedTo[element.taskId]?.join(', ') }}
                      </td>
                                        </ng-container>
                    <ng-container matColumnDef="dueDateStr">
                      <th mat-header-cell *matHeaderCellDef class="header-style"> Due Date </th>
                      <td mat-cell *matCellDef="let element" class="header-style">{{ element.dueDateStr }}</td>
                    </ng-container>
                    <ng-container matColumnDef="status">
                      <th mat-header-cell *matHeaderCellDef class="header-style"> Status </th>
                      <td mat-cell *matCellDef="let element" class="header-style">{{ element.commonStatusDesc }}</td>
                    </ng-container>
                  </ng-container>

                  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                  <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                </table>

                <div class="justify-content-start m-l-10">
                <mat-paginator
  [length]="getSelectedItemsByAgendaId(agenda.agendaId).data.length"
  [pageSize]="10"
  [pageSizeOptions]="[ 10, 20]"
  (page)="onPageChange($event, agenda.agendaId, 'selected')"
  aria-label="Select page">
</mat-paginator>
                </div>
              </ng-container>

              <ng-template #noRecords>
                <div class="text-center p-2" [ngStyle]="{'color':'#888', 'font-style':'italic'}">
                  No records found
                </div>
              </ng-template>
            </div>

          </cdk-accordion-item>
        </cdk-accordion>

        <div class="action-buttons" [ngStyle]="{'text-align':'right', 'margin-top':'20px'}">
          <button mat-button (click)="onCancel()">Cancel</button>
          <button mat-raised-button color="warn" (click)="onRemoveLinkedItems()">
            Remove
          </button>
        </div>
        
        

      </mat-dialog-content>
    </mat-tab>

    <!-- Link Items Tab -->
    <mat-tab label="Link {{ type === 'TASK' ? 'Notes' : 'Tasks' }}" *ngIf="minAttrList && FollowupTask !== 'Y' && minAttrList.deletedFlag != null">
      <div class="dialog-header-container">
        <h2 class="mar-b-5 pd-t-5px" mat-dialog-title> {{meetingTitle}} </h2>
        <div>
          <button mat-icon-button mat-dialog-close aria-label="Close">
            <mat-icon>close</mat-icon>
          </button>
        </div>
      </div>
      <mat-divider class="mat-divider"></mat-divider>
      <mat-dialog-content class="dialog-without-actions">

        <cdk-accordion class="example-accordion" multi="true">
          <cdk-accordion-item *ngFor="let agenda of filteredAgendas" #accordionItem="cdkAccordionItem"
                              [expanded]="isMinutesExist(agenda)" class="example-accordion-item">

            <!-- Header -->
            <div *ngIf="isMinutesExist(agenda)" class="example-accordion-item-header d-flex align-items-center"
                 (click)="accordionItem.toggle()">
              <button mat-icon-button>
                <mat-icon>{{ accordionItem.expanded ? 'keyboard_arrow_down' : 'keyboard_arrow_right' }}</mat-icon>
              </button>
              <h3 class="margin-0 f-weight">
                <div [innerHTML]="agenda.agendaTitle"></div>
              </h3>
            </div>

            <!-- Body -->
            <div class="example-accordion-item-body" *ngIf="accordionItem.expanded && isMinutesExist(agenda)">
              <ng-container *ngIf="(type === 'TASK' ? getItemsByAgendaId(agenda.agendaId).data : getItemsByAgendaId(agenda.agendaId).data).length > 0; else noRecordsLink">
                <table mat-table    [dataSource]="pagedLinkItemsMap[agenda.agendaId] || getItemsByAgendaId(agenda.agendaId).data"
                       class="col-12 mat-elevation-z2 demo-table">

                  <!-- Select Column -->
                  <ng-container matColumnDef="select">
                    <th mat-header-cell *matHeaderCellDef>
                      <mat-checkbox (change)="masterToggle(agenda.agendaId, 'all')"
                      [checked]="isAllSelected(agenda.agendaId, 'all')"></mat-checkbox>
                    </th>
                    <td mat-cell *matCellDef="let element">
                      <mat-checkbox (click)="$event.stopPropagation()"
                                    (change)="toggleSelection(element)"
                                    [checked]="selection.isSelected(element)">
                      </mat-checkbox>
                    </td>
                  </ng-container>

                  <!-- Dynamic Columns -->
                  <ng-container *ngIf="type === 'TASK'">
                    <ng-container matColumnDef="noteDescription">
                      <th mat-header-cell *matHeaderCellDef class="header-style"> Note </th>
                      <td mat-cell *matCellDef="let element"[innerHTML]=element.noteDescription class="header-style"></td>
                    </ng-container>
                    <!-- <ng-container matColumnDef="createdByName">
                      <th mat-header-cell *matHeaderCellDef> Created By </th>
                      <td mat-cell *matCellDef="let element">{{ element.createdByName }}</td>
                    </ng-container> -->
                  </ng-container>

                  <ng-container *ngIf="type === 'NOTE'">
                    <ng-container matColumnDef="taskTitle">
                      <th mat-header-cell *matHeaderCellDef class="header-style"> Task </th>
                      <td mat-cell *matCellDef="let element" [innerHTML]="element.taskTitle" class="header-style"></td>
                    </ng-container>
                    <ng-container matColumnDef="createdByName">
                      <th mat-header-cell *matHeaderCellDef class="header-style"> Assigned By </th>
                      <td mat-cell *matCellDef="let element" class="header-style">{{ element.createdByName }}</td>
                    </ng-container>
                    <ng-container matColumnDef="assignedTo">
                      <th mat-header-cell *matHeaderCellDef class="header-style"> Assigned To </th>
                      <td mat-cell *matCellDef="let element" class="header-style">
                        {{ assignedTo[element.taskId]?.join(', ') }}
                      </td>
                    </ng-container>
                    <ng-container matColumnDef="dueDateStr">
                      <th mat-header-cell *matHeaderCellDef class="header-style"> Due Date </th>
                      <td mat-cell *matCellDef="let element" class="header-style">{{ element.dueDateStr }}</td>
                    </ng-container>
                    <ng-container matColumnDef="status">
                      <th mat-header-cell *matHeaderCellDef class="header-style"> Status </th>
                      <td mat-cell *matCellDef="let element" class="header-style">{{  element.commonStatusDesc }}</td>
                    </ng-container>
                  </ng-container>

                  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                  <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                </table>

                <div class="justify-content-start m-l-10">
                  <mat-paginator
                      [length]=" getItemsByAgendaId(agenda.agendaId).data.length"
                      [pageSize]="10"
                      [pageSizeOptions]="[ 10, 20]"
                      (page)="onPageChange($event, agenda.agendaId, 'all')"
                      aria-label="Select page">
                  </mat-paginator>
                </div>
              </ng-container>

              <ng-template #noRecordsLink>
                <div class="text-center p-2" [ngStyle]="{'color':'#888', 'font-style':'italic'}">
                  No records found
                </div>
              </ng-template>
            </div>

          </cdk-accordion-item>
        </cdk-accordion>

        
          <!-- If we are on Link tab -->
          <div class="action-buttons" [ngStyle]="{'text-align':'right', 'margin-top':'20px'}">
            <button mat-button (click)="onCancel()">Cancel</button>
            <button mat-raised-button color="primary" (click)="onSave()">
              Save
            </button>
          </div>
          
        

      </mat-dialog-content>
    </mat-tab>

  </mat-tab-group>
</div>
